import axios from "axios";
import React, { useEffect, useState } from "react";
import DOMPurify from 'dompurify';
import {Link} from 'react-router-dom';
import OurSuccess from "../component/OurSuccess";
import Partner from "../component/Partner";

const About = () => {

    const [aboutUs,setAboutUs] = useState([]);
    useEffect(() => {
        const fetchAboutUs = async () => {
            const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
            const Url = process.env.REACT_APP_API_ABOUT_US;
            try {
                const response = await axios.get(`${apiBaseUrl}${Url}`);
                setAboutUs(response.data);
            } catch (error) {
                console.error('Failed to fetch About Us:', error);
            }
        };

        fetchAboutUs();
    }, []);

    return (
        <main className="main">
            <div className="site-breadcrumb" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/breadcrumb/01.jpg)`}}>
                <div className="container">
                    <h2 className="breadcrumb-title">আমাদের সম্পর্কে</h2>
                    <ul className="breadcrumb-menu">
                        <li>
                            <Link className="nav-link" to={"/"}>হোম</Link>
                        </li>
                        <li className="active">আমাদের সম্পর্কে</li>
                    </ul>
                </div>
            </div>


            <div className="about-area py-100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="about-left wow fadeInLeft" data-wow-delay=".25s">
                                <div className="about-img">
                                    <div className="row">
                                        <div className="col-6">
                                            <img className="img-1" src="assets/img/1.png" alt=""/>
                                                <img className="shape" src="assets/img/shape/02.png" alt=""/>
                                        </div>
                                        <div className="col-6">
                                            <div className="about-experience">
                                                <h5>20<span>+</span></h5>
                                                <p>Years Of Experience</p>
                                            </div>
                                            <img className="img-2" src="assets/img/3.png" alt=""/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="about-right wow fadeInUp" data-wow-delay=".25s">
                                <div className="site-heading mb-3" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(aboutUs.about_us) }}> 

                                </div>
                        
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <OurSuccess />

            <Partner />

        </main>
    );
}

export default About;